import { createContext, useContext } from 'react';

export const ListKeepAliveContext = createContext(null);

export function useListKeepAlive() {
    return useContext(ListKeepAliveContext);
}
